import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

import * as wheelGetters from "./getters/wheels";
import * as wheelActions from "./actions/wheels";
import * as wheelMutations from "./mutations/wheels";

import * as prizesActions from "./actions/prizes";
import * as prizesMutations from "./mutations/prizes";
import * as prizesGetters from "./getters/prizes";

import * as slotDpActions from "./actions/slotDoorprize";
import * as slotDpMutations from "./mutations/slotDoorprize";

import * as slotActions from "./actions/slot";
import * as slotMutations from "./mutations/slot";

import { getAvailable, getInitialPreset } from "../data";
import { PRESET1 } from "../data/presets";
import { loadOptions, loadPresets } from "../data/storage";
import { deepClone, getParameterByName } from "../util";

Vue.use(Vuex);

const ls = new SecureLS({ encodingType: "aes", isCompression: false });
let options = loadOptions();
const presets = loadPresets();

// Use the preset specified by the parameter, if any.
const initial = getInitialPreset(getParameterByName("preset"), presets);
const data = initial ? deepClone(initial) : deepClone(options || PRESET1);

// If there is no stored options, use the initial data as options.
if (!options) {
  options = deepClone(data);
}

const stateWheel = {
  totalSpins: 0,
  spins: 0,
  lastResult: -1,
  showOptions: false,
  size: 0,
  options,
  data,
  available: deepClone(getAvailable(data.prizes)),
  records: [],
  person: [],
  preset: [],
  grandprizes: [],
};

const wheelModule = {
  state: stateWheel,
  getters: wheelGetters,
  actions: wheelActions,
  mutations: wheelMutations,
};

const prizesModule = {
  state: {
    prizes: [],
    grandprizes: [],
    winners: [],
    lastResult: -1,
    isLoading: false,
    person: [],
  },
  getters: prizesGetters,
  actions: prizesActions,
  mutations: prizesMutations,
};

const slotDpModule = {
  state: {
    person: [],
    gifts: {},
  },
  actions: slotDpActions,
  getters: {
    getDigitPerson(state) {
      // console.log(state.person, "get person")
      const data = state.person
        .map((item) => ({
          userId: item.userId,
          digits: item.digits,
        }))
        .sort(() => 0.5 - Math.random());
      return data.slice(0, +state.gifts.qty);
    },
  },
  mutations: slotDpMutations,
};

const layoutModule = {
  state: {
    layout: "simple-layout",
    loggedIn: null,
    userInfo: {
      id: null,
      userId: null,
      digits: "",
      fotoUrl: "",
      workType: "",
      positionTitle: "",
      // lat: null,
      // lon: null,
      company: "",
      noKado: null,
      // getKado: null,
      // roomName: ""
    },
    user_feedback: {
      dosurvey: false,
      dofeedback: false,
      dovote: false,
    },
  },
  mutations: {
    SET_LAYOUT(state, payload) {
      state.layout = payload;
    },
    SET_LOGIN(state, payload) {
      state.loggedIn = payload;
    },
    SET_USERINFO(state, payload) {
      state.userInfo = payload;
    },
    SET_STATUS_FB(state, payload) {
      // console.log("SET_STATUS_FB " + payload);
      state.user_feedback = payload;
    },
  },
  getters: {
    layout(state) {
      return state.layout;
    },
    loggedIn(state) {
      return state.loggedIn;
    },
    userInfo(state) {
      return state.userInfo;
    },
    userFeedback(state) {
      return state.user_feedback;
    },
  },
};

const slotModule = {
  state: {
    person: [],
    slots: [],
    list_kado: [],
    isLoading: false,
  },
  actions: slotActions,
  mutations: slotMutations,
  getters: {},
};

const store = new Vuex.Store({
  modules: {
    layout: layoutModule,
    spinWheel: wheelModule,
    doorprizes: prizesModule,
    slotDoorprize: slotDpModule,
    slotMachine: slotModule,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});

if (module.hot) {
  module.hot.accept(
    ["./getters/wheels", "./actions/wheels", "./mutations/wheels"],
    () => {
      store.hotUpdate({
        getters: require("./getters/wheels"),
        actions: require("./actions/wheels"),
        mutations: require("./mutations/wheels"),
      });
    }
  );
}

export default store;
